import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { queryClient, QUERY_CACHE_STORAGE_KEY, shouldPersistQuery } from './lib/query-client.js';
import { clearQueryCacheOnSignOut } from './lib/sign-out.js';
import App from './App.js';
import { DemoBanner } from './components/ui/DemoBanner.js';
import { FrameGuard } from './components/ui/FrameGuard.js';
import './design/base.css';
import { registerServiceWorker, registerOfflineSync } from './lib/pwa.js';

// Persist the React Query cache to localStorage so builders can read their
// projects, phases, and invoices while offline on a construction site.
// Stale cached data is shown immediately; fresh data replaces it when online.
const localStoragePersistor = createWebStoragePersistor({
  storage: window.localStorage,
  key: QUERY_CACHE_STORAGE_KEY,
});

persistQueryClient({
  queryClient,
  persistor: localStoragePersistor,
  maxAge: 24 * 60 * 60 * 1000,
  dehydrateOptions: {
    // Only successful queries, and never the role-dependent alert queries.
    shouldDehydrateQuery: shouldPersistQuery,
  },
});

clearQueryCacheOnSignOut();
registerServiceWorker();
registerOfflineSync();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <FrameGuard>
          <App />
        </FrameGuard>
        <DemoBanner />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
